<template>
<div class="nav-outer-wrapper">
  <b-navbar toggleable="md" type="dark" class="primaryNav">
    <b-navbar-brand><img src="../assets/kegs-logo-sml.png"></b-navbar-brand>
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <!--START FIRST NAV SECTION (MAIN TOOLSET) -->
    <b-collapse v-if="authed" is-nav id="nav_collapse">

      <b-navbar-nav v-if="isToolEnabled('comments')" class='navbar-grouped' style="border: none">
      <b-nav-item  data-step="7" data-intro="You can add comments straight onto map. Just drag and drop this button onto a place on map">
        <b-button v-b-tooltip.hover id="comments_btn" :pressed.sync="$store.getters['cmp/all']['comments']['enabled']" title="Comment" variant="dark" class="toolbar-button">
          <icon name="comment" scale=".8" label="Comment"></icon>
        </b-button>

        <b-popover placement="top" v-if="$store.getters['map/currentCommentIssue'] == null" :show.sync="$store.getters['cmp/all']['comments']['enabled']" target="comments_btn" title="Comments" triggers="click">
          <template slot="default">
            <b-button class="btn-block comment-tool-btn" v-b-tooltip.hover.right title="Create Comment" :pressed.sync="commentState">
              <span class='new-note'><icon name="sticky-note"></icon></span>
            </b-button>
          </template>
        </b-popover>

      </b-nav-item>
      </b-navbar-nav>
      <!--Review toolbar-->
      <b-navbar-nav class='navbar-grouped'>



        <template v-if="smallScreen">


          <b-nav-item-dropdown id="review_dropdown">
            <template slot="button-content">
              <span class='navbar-group-title'>
                Review
              </span>
            </template>

            <b-dropdown-item    @click="$store.getters['cmp/all']['layers']['enabled'] = true">
              <icon name="map-marker-alt" scale="1" label="Layer manager"></icon>
              Layer manager
            </b-dropdown-item>

            <b-dropdown-item v-if="isToolEnabled('measure')" @click="$store.getters['cmp/all']['measure']['enabled'] = true">
              <icon name="arrows-alt-h" scale="1" label="Measure"></icon>
              Measure
            </b-dropdown-item>

            <b-dropdown-item  v-if="isToolEnabled('info')" @click="$store.getters['cmp/all']['info']['enabled'] = true">
              <icon name="info-circle" scale="1" label="Info"></icon>
              Info
            </b-dropdown-item>

            <b-dropdown-item  v-if="isToolEnabled('flow_chart')" @click="$store.getters['cmp/all']['flow']['enabled'] = true">
              <icon v-if="$store.getters['map/loadingFlowInteraction']" name="spinner" scale="1" label="Flow Data Loading" pulse></icon>
              <icon v-else name="chart-area" scale="1" label="Flow Data"></icon>
              Flow
            </b-dropdown-item>

            <b-dropdown-item  v-if="$store.getters['project/currentProject']" @click="profileShow = !profileShow">
              <icon name="chart-line" scale="1" label="Info"></icon>
              Profile
            </b-dropdown-item>


            <b-dropdown-item  v-if="isToolEnabled('potree')" @click="$store.getters['cmp/all']['pc']['enabled'] = true">
              <icon name="cube" scale="1" label="Info"></icon>
              3D
            </b-dropdown-item>

            <b-dropdown-item  v-if="isToolEnabled('bowen_stats')" @click="$store.getters['cmp/all']['bowen_stats']['enabled'] = true">
              <icon name="list" scale="1" label="Info"></icon>
              Bowen Stats
            </b-dropdown-item>




<!--            <b-dropdown-item v-b-tooltip.hover id="comments_btn"  v-if="isToolEnabled('comments')" @click="$store.getters['cmp/all']['comments']['enabled'] = !$store.getters['cmp/all']['comments']['enabled']">
              <icon name="comment" scale="1" label="Info"></icon>
              Comments
            </b-dropdown-item>-->





            <template v-if="isToolEnabled('permalink')">

              <b-dropdown-item  v-if="isToolEnabled('permalink')" @click="$store.commit('map/linkShow', true)">
                <icon name="link" scale="1" label="Info"></icon>
                Permalink
              </b-dropdown-item>


              <b-popover placement="left" target="zoom_to_bounds" title="Permalink" :show.sync="linkShow" @click="$store.commit('map/linkShow', false)">
                <permalink></permalink>
              </b-popover>

            </template>

            <b-dropdown-item @click="temporalShow = !temporalShow"  v-if="isToolEnabled('temporal_scale') && $store.getters['project/currentProject']">
              <icon name="play-circle" scale="1" label="Info"></icon>
              Temporal player
            </b-dropdown-item>

            <b-dropdown-item  v-if="isToolEnabled('history')" @click="$store.getters['cmp/all']['history']['enabled'] = true">
              <icon name="history" scale="1" label="History"></icon>
              History
            </b-dropdown-item>

            <b-dropdown-item  v-if="isToolEnabled('westside_production')" @click="$store.getters['cmp/all']['westside_production']['enabled'] = true">
              <icon name="wall" scale="1" label="Westside production"></icon>
              Westside production
            </b-dropdown-item>

          </b-nav-item-dropdown>


        </template>
        <template v-else>
      <span class='navbar-group-title'>
          Review
        </span>
          <b-nav-item data-step="1" data-intro="Layer Manager allows enabling/disabling layers, compounding, showing and hiding feature labels, viewing feature attributes and other options" v-if="$store.getters['project/currentProject']">
            <b-button id="layer_manager_btn" :pressed.sync="$store.getters['cmp/all']['layers']['enabled']" v-b-tooltip.hover title="Layer manager" variant="dark" class="toolbar-button tool1">
              <icon name="map-marker-alt" scale=".8" label="Layer manager">
              </icon>
            </b-button>
          </b-nav-item>

          <!-- <b-nav-item v-if="$store.getters['project/currentProject']" class="divider"></b-nav-item> -->
          <!-- Data vis and information stuff -->
          <b-nav-item v-if="isToolEnabled('measure')" data-step="2" data-intro="To quickly measure length or area use the Measure Tool">
            <b-button v-b-tooltip.hover :pressed.sync="$store.getters['cmp/all']['measure']['enabled']" title="Measure tool" variant="dark" class="toolbar-button">
              <icon name="arrows-alt-h" scale=".8" label="Measure tool"></icon>
            </b-button>
          </b-nav-item>

          <b-nav-item v-if="isToolEnabled('info')" data-step="3" data-intro="Info Tool helps to inspect spatial information and attributes of features">
            <b-button v-b-tooltip.hover :pressed.sync="$store.getters['cmp/all']['info']['enabled']" title="Info tool" variant="dark" class="toolbar-button">
              <icon name="info-circle" scale=".8" label="Info tool"></icon>
            </b-button>
          </b-nav-item>

          <b-nav-item v-if="isToolEnabled('flow_chart')" data-step="4" data-intro="In the Tasks interface you can view completed or current tasks, also start new background processes">
            <b-button v-b-tooltip.hover :pressed.sync="$store.getters['cmp/all']['flow']['enabled']" title="Flow Data" variant="dark" class="toolbar-button">
              <icon v-if="$store.getters['map/loadingFlowInteraction']" name="spinner" scale=".8" label="Flow Data Loading" pulse></icon>
              <icon v-else name="chart-area" scale=".8" label="Flow Data"></icon>
            </b-button>
          </b-nav-item>

          <b-nav-item v-if="$store.getters['project/currentProject']" data-step="5" data-intro="Profile widget designed to inspect elevation and location profile for corridor and some of its features like LPD and HPV">
            <b-button v-b-tooltip.hover :pressed.sync="profileShow" title="Profile" variant="dark" class="toolbar-button">
              <icon name="chart-line" scale=".8" label="Profile"></icon>
            </b-button>
          </b-nav-item>

          <b-nav-item v-if="isToolEnabled('potree')" data-step="6" data-intro="The 3D Viewer renders the current map in 3D in a seperate window for the user">
            <b-button v-b-tooltip.hover :disabled="!$store.getters['map/potreeLoaded']" :pressed.sync="$store.getters['cmp/all']['pc']['enabled']" title="3D Viewer" variant="dark" class="toolbar-button">
              <icon name="cube" scale=".8" label="Point cloud viewer"></icon>
            </b-button>
          </b-nav-item>

          <b-nav-item v-if="isToolEnabled('bowen_stats')" data-step="6" data-intro="Statistics for bowen project">
            <b-button v-b-tooltip.hover :pressed.sync="$store.getters['cmp/all']['bowen_stats']['enabled']" title="Bowen Stats" variant="dark" class="toolbar-button">
              <icon name="list" scale=".8" label="Bowen Stats"></icon>
            </b-button>
          </b-nav-item>


<!--          <b-nav-item v-if="isToolEnabled('comments')" data-step="7" data-intro="You can add comments straight onto map. Just drag and drop this button onto a place on map">
            <b-button v-b-tooltip.hover id="comments_btn" :pressed.sync="$store.getters['cmp/all']['comments']['enabled']" title="Comment" variant="dark" class="toolbar-button">
              <icon name="comment" scale=".8" label="Comment"></icon>
            </b-button>

            <b-popover placement="top" v-if="$store.getters['map/currentCommentIssue'] == null" :show.sync="$store.getters['cmp/all']['comments']['enabled']" target="comments_btn" title="Comments" triggers="click">
              <template slot="default">
                <b-button class="btn-block comment-tool-btn" v-b-tooltip.hover.right title="Create Comment" :pressed.sync="commentState">
                  <span class='new-note'><icon name="sticky-note"></icon></span>
                </b-button>
              </template>
            </b-popover>

          </b-nav-item>-->

          <template v-if="isToolEnabled('permalink')">
            <b-nav-item data-step="8" data-intro="Permalink will help you to share particular map view">
              <b-button id="prmalink_btn" :pressed.sync="linkShow" v-b-tooltip.hover title="Permalink" variant="dark" class="toolbar-button">
                <icon name="link" scale=".8" label="Permalink"></icon>
              </b-button>
            </b-nav-item>
            <b-popover placement="top" target="prmalink_btn"  title="Permalink" :show.sync="linkShow">
              <permalink></permalink>
            </b-popover>
          </template>

          <b-nav-item v-if="isToolEnabled('temporal_scale') && $store.getters['project/currentProject'] && this.$store.getters['map/temporalLayers'].length > 0" data-step="14" data-intro="Some layers have time dimension. This widget will allow you to animate/filter time-enabled layers">
            <b-button v-b-tooltip.hover :pressed.sync="temporalShow" title="Temporal player" variant="dark" class="toolbar-button">
              <icon name="play-circle" scale=".8" label="Temporal player"></icon>
            </b-button>
          </b-nav-item>

          <b-nav-item v-if="isToolEnabled('history')" data-step="9" data-intro="History widget allows to search for changed in data and see when and whom they were made">
            <b-button v-b-tooltip.hover :pressed.sync="$store.getters['cmp/all']['history']['enabled']" title="History" variant="dark" class="toolbar-button">
              <icon name="history" scale=".8" label="History"></icon>
            </b-button>
          </b-nav-item>

          <b-nav-item v-if="isToolEnabled('westside_production')" >
            <b-button v-b-tooltip.hover :pressed.sync="$store.getters['cmp/all']['westside_production']['enabled']" title="Westside production" variant="dark" class="toolbar-button">
              <icon name="wall" scale=".8" label="Westside production"></icon>
            </b-button>
          </b-nav-item>

        </template>


      </b-navbar-nav>

      <!--End of review toolbar-->

      <!--build toolbar-->
      <b-navbar-nav class='navbar-grouped'>

        <template v-if="!smallScreen">
          <span class='navbar-group-title'>
          Build
        </span>
          <!-- <b-nav-item v-if="$store.getters['project/currentProject']" class="divider"></b-nav-item> -->
          <!-- Management, reports and user stuff -->
          <b-nav-item v-if="isToolEnabled('tasks')" data-step="10" data-intro="The task tool shows previously run tasks for this workpack & allows this user to schedule new tasks">
            <b-button v-b-tooltip.hover :pressed.sync="$store.getters['cmp/all']['tasks']['enabled']" title="Task manager" variant="dark" class="toolbar-button">
              <icon name="tasks" scale=".8" label="Task manager"></icon>
            </b-button>
          </b-nav-item>

          <b-nav-item>
            <b-button v-if="isToolEnabled('reports')" data-step="11" data-intro="This tool will open up a file browser window which will allow the user navigate & find a past job report" v-b-tooltip.hover :pressed.sync="$store.getters['cmp/all']['reports']['enabled']"
                      title="Report browser" variant="dark" class="toolbar-button">
              <icon name="file-archive" scale=".8" label="Report Browser">
              </icon>
            </b-button>
          </b-nav-item>

          <!-- Designatron - probably wrap this in a div so it only appears when its a designatron project or we could jus toggle it inactive, whateer suits -->
          <b-nav-item v-if="isToolEnabled('designo_tron') && $store.getters['map/layersLoaded'] && isAwpEditor" data-step="12" data-intro="The designatron tool will allow the user to edit layer features & attributes">
            <b-button :pressed.sync="$store.getters['map/designotron']['enabled']" v-b-tooltip.hover title="Designatron" variant="dark" class="toolbar-button designatron-button">
              <img src="../assets/designatron.svg">
            </b-button>
          </b-nav-item>

          <!-- <b-nav-item v-if="isToolEnabled('designo_tron') $store.getters['map/layersLoaded'] && isLogEditor" data-step="13" data-intro="The logitron tool will allow the user to edit layer features & attributes relating to logistics layers ">
            <b-button :pressed.sync="$store.getters['map/logitron']['enabled']" v-b-tooltip.hover title="Logitron" variant="dark" class="toolbar-button designatron-button"><img src="../assets/logitron.svg"></b-button>
          </b-nav-item> -->

          <b-nav-item v-if="isToolEnabled('qa_tool')" data-step="15" data-intro="Inspect qa issues on map">
            <b-button v-b-tooltip.hover :pressed.sync="$store.getters['cmp/all']['qa_tool']['enabled']" title="Qa Tool" variant="dark" class="toolbar-button">
              <icon name="check-square" scale=".8" label="QA issues"></icon>
            </b-button>
          </b-nav-item>

          <b-nav-item v-if="$store.getters['project/currentProject'] && $store.getters['map/layersLoaded'] && $store.getters['map/printMode']">
            <b-button @click="$store.commit('map/printProfile', new Date().getTime())" v-b-tooltip.hover title="Print Profile" variant="dark" class="toolbar-button">
              <icon name="print" scale=".8" label="Support"></icon>
            </b-button>
          </b-nav-item>


          <b-nav-item v-if="isToolEnabled('clone')" data-step="17" data-intro="Clone model or part of it into a new workpack">
            <b-button v-b-tooltip.hover :pressed.sync="$store.getters['cmp/all']['clone']['enabled']" title="Clone model" variant="dark" class="toolbar-button">
              <icon name="copy" scale=".8"></icon>
            </b-button>
          </b-nav-item>

        </template>
        <template v-else>
          <b-nav-item-dropdown>
            <template slot="button-content">
              <span class='navbar-group-title'>
                Build
              </span>
            </template>

            <b-dropdown-item v-if="isToolEnabled('tasks')" @click="$store.getters['cmp/all']['tasks']['enabled'] = true">
              <icon name="tasks" scale="1" label="Task manager"></icon>
              Task manager
            </b-dropdown-item>

            <b-dropdown-item v-if="isToolEnabled('reports')" @click="$store.getters['cmp/all']['reports']['enabled'] = true">
              <icon name="file-archive" scale="1" label="Report Browser"></icon>
              Report Browser
            </b-dropdown-item>

            <b-dropdown-item v-if="isToolEnabled('designo_tron') && $store.getters['map/layersLoaded'] && isAwpEditor" @click="$store.getters['map/designotron']['enabled'] = !$store.getters['map/designotron']['enabled']">
              <icon name="dtron" scale="1"></icon>
              Designatron
            </b-dropdown-item>

            <b-dropdown-item v-if="$store.getters['map/layersLoaded'] && isLogEditor" @click="$store.getters['map/logitron']['enabled'] = !$store.getters['map/logitron']['enabled']">
              <icon name="logitron" scale="1"></icon>
              Logitron
            </b-dropdown-item>

            <b-dropdown-item  v-if="isToolEnabled('qa_tool')" @click="$store.getters['cmp/all']['qa_tool']['enabled'] = true">
              <icon name="check-square" scale="1" label="QA Issues"></icon>
              QA issues
            </b-dropdown-item>

            <b-dropdown-item  @click="$store.commit('map/printProfile', new Date().getTime())"  v-if="$store.getters['project/currentProject'] && $store.getters['map/layersLoaded'] && $store.getters['map/printMode']">
              <icon name="print" scale="1" label="QA issues"></icon>
              Print Profile
            </b-dropdown-item>


            <b-dropdown-item @click="$store.getters['cmp/all']['clone']['enabled'] = true" >
              <icon name="copy" scale="1" label="Clone"></icon>
              Clone model
            </b-dropdown-item>




          </b-nav-item-dropdown>
        </template>


      </b-navbar-nav>
      <!--End of build toolbar-->

      <!--Stats toolbar-->
    <b-navbar-nav class='navbar-grouped' v-if="isToolEnabled('project_stats') && project && project.workpack">

      <template v-if="smallScreen">
        <b-nav-item-dropdown>
          <template slot="button-content">
              <span class='navbar-group-title'>
                Score
              </span>
          </template>

          <b-dropdown-item @click="$store.getters['cmp/all']['scorecard']['enabled'] = !$store.getters['cmp/all']['scorecard']['enabled']" >
            <icon name="table" scale="1" label="Stats"></icon>
            Stats
          </b-dropdown-item>
        </b-nav-item-dropdown>


      </template>
      <template v-else>
        <span class='navbar-group-title'>
        Score
      </span>
        <b-nav-item data-step="16" data-intro="Details project statistics">
          <b-button  v-b-tooltip.hover :pressed.sync="$store.getters['cmp/all']['scorecard']['enabled']" title="Project Stats" variant="dark" class="toolbar-button">
            <icon name="table" scale=".8" label="Stats"></icon>
          </b-button>
        </b-nav-item>
      </template>

    </b-navbar-nav>
    </b-collapse>
    <!--END FIRST NAV SECTION (MAIN TOOLSET) -->
    <project-browser v-if="authed"></project-browser>
    <!--START FAR RIGHT BUTTONS -->
    <b-navbar-nav v-if="authed" class="my-0 right-nav-btns">
      <b-nav-item>
        <b-button :pressed.sync="showWG" v-b-tooltip.hover title="Show/hide all windows" class="nav-link bg-inverse show-hide-button">
          <icon name="eye"></icon>
        </b-button>
      </b-nav-item>
      <b-nav-item data-intro="The search widget will help you find wells and centrelines by their idents" data-step="17">
        <b-button :pressed.sync="showSearch" v-b-tooltip.hover title="Search for projects or feature" class="nav-link bg-inverse show-hide-button">
          <icon name="search"></icon>
        </b-button>
      </b-nav-item>
      <b-nav-item>
        <b-button v-b-tooltip.hover.bottom title="User Menu" v-if="authed" @click="toggleRightMenu" class="showRight nav-link user-menu-button bg-inverse"><span class="menu-icon">
            <icon name="bars"></icon>
          </span></b-button>
      </b-nav-item>
    </b-navbar-nav>
    <!--END FAR RIGHT BUTTONS -->
  </b-navbar>
</div>
</template>

<script>
import 'vue-awesome/icons/map-marker-alt'
import 'vue-awesome/icons/comment'
import 'vue-awesome/icons/print'
import 'vue-awesome/icons/link'
import 'vue-awesome/icons/check-square'
import 'vue-awesome/icons/chart-area'
import 'vue-awesome/icons/arrows-alt-h'
import 'vue-awesome/icons/info-circle'
import 'vue-awesome/icons/tasks'
import 'vue-awesome/icons/file-archive'
import 'vue-awesome/icons/cube'
import 'vue-awesome/icons/circle'
import 'vue-awesome/icons/edit'
import 'vue-awesome/icons/sun'
import 'vue-awesome/icons/table'
import 'vue-awesome/icons/eye'
import 'vue-awesome/icons/sign-out-alt'
import 'vue-awesome/icons/eye-slash'
import 'vue-awesome/icons/angle-down'
import 'vue-awesome/icons/play-circle'
import 'vue-awesome/icons/chart-line'
import 'vue-awesome/icons/image'
import 'vue-awesome/icons/life-ring'
import 'vue-awesome/icons/sticky-note'
import 'vue-awesome/icons/bars'

import 'vue-awesome/icons/tree'
import 'vue-awesome/icons/square'

import 'vue-awesome/icons/notes-medical'

import ProjectBrowser from './projects/ProjectBrowser.vue'
import Vue from 'vue'
import Permalink from './map/Permalink'
import Icon from 'vue-awesome/components/Icon'

Icon.register({
  dtron: {
    width: 96,
    height: 96,
    raw: '<path class="cls-1" d="M22.41,45.12,3,25.72a3.46,3.46,0,0,1,0-4.91H3L20.81,3a3.46,3.46,0,0,1,4.91,0h0l19.4,19.4a.82.82,0,0,1,0,1.17h0l-3.73,3.73a.83.83,0,0,1-1.17,0L38.3,25.39,34.8,28.9a1.77,1.77,0,0,1-2.5,0,1.43,1.43,0,0,1-.2-.23,1.84,1.84,0,0,1,.26-2.34l3.42-3.42-2.5-2.5L29.79,23.9a1.77,1.77,0,0,1-2.5,0,1.43,1.43,0,0,1-.2-.23,1.84,1.84,0,0,1,.26-2.34l3.42-3.42-2.5-2.5L24.78,18.9a1.77,1.77,0,0,1-2.5,0,1.43,1.43,0,0,1-.2-.23,1.84,1.84,0,0,1,.26-2.34l3.42-3.42-2.5-2.5L10.38,23.26l16.94,17a.82.82,0,0,1,0,1.17h0l-3.73,3.73a.82.82,0,0,1-1.17,0Zm55.17,9.77a.82.82,0,0,0-1.17,0h0l-3.73,3.73a.82.82,0,0,0,0,1.17h0l1.92,1.92-3.42,3.42a1.84,1.84,0,0,0-.26,2.34,1.78,1.78,0,0,0,2.47.43l.23-.2,3.49-3.49,2.5,2.5-3.42,3.42a1.84,1.84,0,0,0-.26,2.34,1.78,1.78,0,0,0,2.47.43l.23-.2,3.49-3.49,2.5,2.5-3.42,3.42a1.84,1.84,0,0,0-.26,2.34,1.78,1.78,0,0,0,2.47.43l.23-.2,3.49-3.49,2.5,2.5L76.74,89.62,59.79,72.68a.82.82,0,0,0-1.17,0h0l-3.73,3.73a.82.82,0,0,0,0,1.17h0L74.28,97a3.46,3.46,0,0,0,4.91,0h0L97,79.19a3.46,3.46,0,0,0,0-4.91h0ZM95.38,26.1,36.61,84.87a9.63,9.63,0,0,1-4.17,2.46l-20.5,5.89a4.16,4.16,0,0,1-4.09-1.06h0a4.16,4.16,0,0,1-1.06-4.09l5.89-20.51a9.63,9.63,0,0,1,2.46-4.17L73.91,4.61a8.53,8.53,0,0,1,12,0L95.39,14a8.52,8.52,0,0,1,0,12.05l0,0Zm-15.12-15a2.76,2.76,0,0,0-3.46.41L20,68.39a2.67,2.67,0,0,0-.76,1.66L16.45,79.6l4,4,10.13-2.91A2.77,2.77,0,0,0,31.7,80l1.49-1.49-.06-.06a30.69,30.69,0,0,1-6.29-5c-.54-.54-1.05-1.09-1.54-1.63a.87.87,0,0,1,0-1.2L80.68,15.27a2.69,2.69,0,0,0,0-3.8,2.25,2.25,0,0,0-.41-.34Z" transform="translate(-1.98 -1.98)"/>'
  },
  logitron: {
    width: 46,
    height: 54,
    raw: '<path class="cls-1" d="M34,7.81H25.13a1.57,1.57,0,0,0-1.57,1.56v8.87a1.58,1.58,0,0,0,1.57,1.57H34a1.57,1.57,0,0,0,1.57-1.57V9.37A1.56,1.56,0,0,0,34,7.81Zm-1.56,8.87H26.69V10.94h5.74Z" transform="translate(-4 -0.1)"/><path class="cls-1" d="M50,25.77C50.08,20,49.13.1,30,.1,4.88.1,8.09,22.35,8.31,24.86s-2.69,4.95-3.95,6.81S5.53,34,5.53,34H8.05s1.19,1.65.15,2.24-.06,2.28.59,2.34c0,0-.59,1.56-.2,2.08s1.63,1.63,1.56,2.6-1,2.48-.32,3.26,1.36,1.56,4.55,1.56,6-.65,7,.91.78,4.94.78,4.94l23.38-.06s-4.08-6.64-2.78-11.58S49.91,31.59,50,25.77ZM32.56,31c0-3.36-4.13-7.14-7.2-6.24-6.57,1.92-8.25-1.68-8.65-4.81-.32-2.48-6.32-3.84-6.32-3.84A16.8,16.8,0,0,1,14.3,7.58C17.63,3.89,22.93,2,30,2c5,0,9.09,1.51,12,4.5,3.71,3.76,5.87,9.71,3.87,13.69Z" transform="translate(-4 -0.1)"/><rect class="cls-1" x="16.17" y="12.41" width="2.61" height="1.04"/><rect class="cls-1" x="16.17" y="10.84" width="2.61" height="1.04"/><rect class="cls-1" x="16.17" y="9.28" width="2.61" height="1.04"/><rect class="cls-1" x="16.17" y="17.1" width="2.61" height="1.04"/><rect class="cls-1" x="16.17" y="15.54" width="2.61" height="1.04"/><rect class="cls-1" x="16.17" y="13.97" width="2.61" height="1.04"/><rect class="cls-1" x="21.13" y="4.32" width="1.04" height="2.61"/><rect class="cls-1" x="25.82" y="4.32" width="1.04" height="2.61"/><rect class="cls-1" x="24.26" y="4.32" width="1.04" height="2.61"/><rect class="cls-1" x="22.69" y="4.32" width="1.04" height="2.61"/><rect class="cls-1" x="27.39" y="4.32" width="1.04" height="2.61"/><rect class="cls-1" x="28.95" y="4.32" width="1.04" height="2.61"/><rect class="cls-1" x="21.13" y="20.49" width="1.04" height="2.61"/><rect class="cls-1" x="25.82" y="20.49" width="1.04" height="2.61"/><rect class="cls-1" x="24.26" y="20.49" width="1.04" height="2.61"/><rect class="cls-1" x="22.69" y="20.49" width="1.04" height="2.61"/><rect class="cls-1" x="27.39" y="20.49" width="1.04" height="2.61"/><rect class="cls-1" x="28.95" y="20.49" width="1.04" height="2.61"/><rect class="cls-1" x="32.34" y="9.28" width="2.61" height="1.04"/><rect class="cls-1" x="32.34" y="12.41" width="2.61" height="1.04"/><rect class="cls-1" x="32.34" y="10.84" width="2.61" height="1.04"/><rect class="cls-1" x="32.34" y="17.1" width="2.61" height="1.04"/><rect class="cls-1" x="32.34" y="15.54" width="2.61" height="1.04"/><rect class="cls-1" x="32.34" y="13.97" width="2.61" height="1.04"/>'
  }
})

export default {
  name: 'Navbar',
  components: {
    Permalink,
    ProjectBrowser
  },
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',

    }
  },
  created() {
    this.widgets = {}
    this.mapEnabled = {}
    this.nodes = {}
  },
  computed: {
    smallScreen() {
      return (window.innerWidth || document.documentElement.clientWidth) < 1300
    },
    authed() {
      return this.$store.getters['user/authed'] && this.$store.getters['user/verified']
    },
    project() {
      return this.$store.getters['project/currentProject']
    },
    linkShow: {
      get() {
        return this.$store.getters['map/linkShow']
      },
      set(val) {
        this.$store.commit('map/linkShow', val)
      },
    },
    showSearch: {
      get() {
        return this.$store.getters['map/searchShow']
      },
      set(val) {
        this.$store.commit('map/searchShow', val)
      },
    },
    showProjectList: {
      get() {
        return this.$store.getters['project/showProjectList']
      },
      set(val) {
        this.$store.commit('project/showProjectList', val)
      },
    },
    showWG: {
      get() {
        return this.$store.getters['project/showWidgetGrid']
      },
      set(val) {
        this.$store.commit('project/showWidgetGrid', val)
      },
    },
    profileShow: {
      get() {
        return this.$store.getters['map/profileShow']
      },
      set(val) {
        this.$store.commit('map/profileShow', val)
      },
    },
    temporalShow: {
      get() {
        return this.$store.getters['map/temporalShow']
      },
      set(val) {
        this.$store.commit('map/temporalShow', val)
      },
    },
    commentState: {
      get() {
        return this.$store.getters['map/commentState']
      },
      set(val) {
        this.$store.commit('map/commentState', val)
      }
    },
    allCmps: {
      get() {
        return this.$store.getters['cmp/all']
      },
      set(val) {
        return this.$store.commit('cmp/update', val)
      }
    },
    isAwpEditor() {
      return this.$store.getters['user/user']['groups'] && this.$store.getters['user/user']['groups'].map(g => g.name).filter(name => name === 'awp_editor').length > 0
    },
    isLogEditor() {
      return this.$store.getters['user/user']['groups'] && this.$store.getters['user/user']['groups'].map(g => g.name).filter(name => name === 'logistics').length > 0
    },
    isPolEditor() {
      // return true
      return this.$store.getters['user/user']['groups'] && this.$store.getters['user/user']['groups'].map(g => g.name).filter(name => name === 'Polytron').length > 0
    },
    menuRightCls: {
      get() {
        return this.$store.getters['user/menuRightCls']
      },
      set(val) {
        this.$store.commit('user/menuRightCls', val)
      }
    }
  },

  mounted() {
    this.$watch('allCmps', (val) => {
      Object.keys(val).forEach(k => {
        let v = val[k]
        if (v.nogrid) {
          return
        }
        if (!v.loading && localStorage.getItem(k + '-unlocked') == true) {
          v.unlocked = true
        }
        if (v.enabled && !this.mapEnabled[k]) {
          if(v.unlocked) {
            this.enableUnlockedWidget(k, v)
          } else {
            this.enabledWidget(k, v)
          }
        }
        if (!v.enabled && this.mapEnabled[k]) {
          if (v.unlocked) {
            this.disableUnlockedWidget(k, v)
          } else {
            this.disabledWidget(k, v)
          }
        }
        if (v.loading && v.enabled && this.mapEnabled[k]) {
          if (v.unlocked) {
            this.disabledWidget(k, v)
            this.enableUnlockedWidget(k, v)
          } else {
            this.disableUnlockedWidget(k, v)
            this.enabledWidget(k, v)
          }
          v.loading = false
        }
      })
    }, {
      deep: true
    })
  },
  methods: {
    toggleRightMenu() {
      this.showSearch = false
      this.showProjectList = false
      this.menuRightCls = this.menuRightCls !== '' ? '' : 'spmenu-open'
    },
    isToolEnabled(toolName) {
      let currentProject = this.$store.getters['project/currentProject']
      if (!currentProject || !currentProject.workpack) {
        return false
      }
      let enabled = true
      if (currentProject.workpack && currentProject.workpack['tool_map']) {
        enabled = currentProject.workpack['tool_map']['*'] || currentProject.workpack['tool_map'][toolName]
      }
      return enabled
    },
    enableUnlockedWidget(name, options) {
      let height = 500
      let width = 500
      let size = 0
      if (!this.widgets[name]) {
        this.widgets[name] = this.createWidget(options)
      }
      // store in localstoreage unlocked state
      localStorage.setItem(name + '-unlocked', true)

      if (localStorage.getItem(name + '-unlocked-size')) {
        size = localStorage.getItem(name + '-unlocked-size').split(',')
        height = size[0]
        width = size[1]
      }
      this.mapEnabled[name] = true
      let node = $('<bcard class="unlocked-window" id="unlocked-'+name+'" style="position: absolute; width:'+width+'px; height: '+ height+'px;"></bcard>').append(this.widgets[name].$el)
      node.draggable()
      $('#unlocked-window-container').append(node)
      node.draggable( "option", "cancel", ".layerManager-top" )
      node.draggable( "option", "cancel", "#potree-map" )
      node.draggable( "option", "cancel", "#filterLayerGroup" )
      $('#unlocked-'+name).resizable({
        resize: function(event,ui){
           localStorage.setItem(name + '-unlocked-size', ui.size.height + ',' + ui.size.width)
        }
      })
    },
    disableUnlockedWidget(name, options) {

      if (options.onBeforeClose) {
        options.onBeforeClose.call(this)
      }

      // store in localstoreage unlocked state
      localStorage.setItem(name + '-unlocked', false)

      let tool_name = "#unlocked-"+name
      $(tool_name).remove()

      this.mapEnabled[name] = false

      if (options.destroyable) {
        this.widgets[name].$destroy()
        $(this.widgets[name].$el).remove();
        this.widgets[name] = null

        if (options.onDestroy) {
          options.onDestroy.call(this)
        }
      }
    },
    enabledWidget(name, options) {
      let grid = window.widgetsGridStack.data('gridstack')
      if (!this.widgets[name]) {
        this.widgets[name] = this.createWidget(options)
      }

      let node = $('<div style="pointer-events: none"><div class="grid-stack-item-content" style="pointer-events: none" /><div/>').append(this.widgets[name].$el)
      this.nodes[name] = node
      // split localStorage dimensions string into array
      let dimensions
      let localDimension = localStorage.getItem(name)
      if (localDimension && localDimension.length) {
        dimensions = localDimension.split(",")
      }

      if (name === 'comments') {
        grid.addWidget(node, options.x, options.y, options.w, options.h, true, options.minWidth, options.maxWidth, options.minHeight, options.maxHeight, name);
        this.mapEnabled[name] = true
      } else {
        // check if widget fits with saved dimensions else use widget defaults
        if (dimensions && dimensions.length && grid.willItFit(options.x, options.y, dimensions[0], dimensions[1], true)) {
          grid.addWidget(node, options.x, options.y, dimensions[0], dimensions[1], true, options.minWidth, options.maxWidth, options.minHeight, options.maxHeight, name);
          this.mapEnabled[name] = true
        } else if (grid.willItFit(options.x, options.y, options.w, options.h, true)) {
          grid.addWidget(node, options.x, options.y, options.w, options.h, true, options.minWidth, options.maxWidth, options.minHeight, options.maxHeight, name);
          this.mapEnabled[name] = true
        } else {
          grid.addWidget(node,  0,  0, 3, 3, true, undefined, undefined, undefined, undefined, name);
          this.mapEnabled[name] = true
          this.$notify({
            title: 'ERROR',
            text: 'Not enough free space to place the widget',
            type: 'error'
          })

          this.$store.getters['cmp/all'][name]['enabled'] = true
        }
      }


    },
    disabledWidget(name, options) {
      if (options.onBeforeClose) {
        options.onBeforeClose.call(this)
      }
      let grid = window.widgetsGridStack.data('gridstack')
      grid.removeWidget(this.nodes[name])
      this.mapEnabled[name] = false

      if (options.destroyable) {
        this.widgets[name].$destroy()
        $(this.widgets[name].$el).remove();
        this.widgets[name] = null

        if (options.onDestroy) {
          options.onDestroy.call(this)
        }
      }
    },
    createWidget(options) {
      let ComponentClass = Vue.extend(options.clazz)
      let instance = new ComponentClass({
        propsData: options.propsData || {}
      })
      instance.$mount()
      return instance
    }
  },
  watch: {
    showSearch (val) {
      if (val) {
        this.menuRightCls = ''
        this.showProjectList = false
      }
    },
    showProjectList (val) {
      if (val) {
        this.menuRightCls = ''
        this.showSearch = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue